
import RcDomainMap from "../../common/RcDomainMap.js";
import Payment from './Payment.js';
import InvoiceUtils from "./InvoiceUtils.js";

export default class PaymentMap extends RcDomainMap {
  static MODEL_NAME = Payment.MODEL_NAME + "Map";

  constructor(domain, data) {
    super(domain, data, PaymentMap.MODEL_NAME);
  }

  copy() {
    var data = this._copy();
    return new PaymentMap(this.domain, data);
  }

  list() {
    var values = [];
    var keys = this.keys();
    for (var index = 0; index < keys.length; index++) {
      var key = keys[index];
      var item = this.getPayment(key);
      values.push(item);
    }
    return values;
  }

  active() {
    var found = new PaymentMap(this.domain, {});
    var keys = this.keys();
    for (var index = 0; index < keys.length; index++) {
      var key = keys[index];
      var item = this.getPayment(key);
      if (item.isStateActive()) {
        found.add(item);
      }
    }
    return found;
  }

  find() {
    var found = new PaymentMap(this.domain, {});
    var keys = this.keys();
    for (var index = 0; index < keys.length; index++) {
      var key = keys[index];
      var data = this.domain.invoices().payments().findById(key);
      var item = new Payment(this.domain, data);
      if (!item.isNew()) {
        found.add(item);
      }
    }
    return found;
  }

  getPayment(key) {
    var value = super.get(key);
    return new Payment(this.domain, value);
  }

  findOverpaymentPayment() {
    var keys = this.keys();
    for (var index = 0; index < keys.length; index++) {
      var key = keys[index];
      var item = this.getPayment(key);
      if (item.isOverpaymentType()) {
        return item;
      }
    }
    return new Payment(this.domain, {});
  }

  sort() {
    return this.sortByCreatedDate();
  }

  sortByCreatedDate() {
    var list = this.list();
    return list.sort(InvoiceUtils.SortByCreatedDate);
  }

  first() {
    var all = this.list();
    if (all.length > 0) {
      return all[0];
    }
    return new Payment(this.domain);
  }

  display() {
    let display = '';
    var all = this.sort();
    for (var index = 0; index < all.length; index++) {
      var item = all[index];
      if (item.isStateActive()) {
        display += '\n' + (index+1) + '. ' + item.notes();
      }
    }
    return display;
  }
}